import * as signalR from "@microsoft/signalr";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { refetchAllAppointmentsApis } from "../api/Appointments/refetchAllAppointmentsApis";
import { AppConfig } from "../api/config/config";
import ic_notification from "../assets/images/icons/bell.svg";
import Dropdown from "../components/Dropdown/Dropdown";
import { EndPoints } from "../Constants/endpoints";
import { useGetData, usePostData, useSound } from "../hooks";
import { INotificationResponseData } from "../interface/GeneralResponse";
import { NotificationPopUp, NotificationToast } from "./components";

function Notifications() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [newNotification, setNewNotification] = useState<any>();

  const { data: notificationsData, refetch } =
    useGetData<INotificationResponseData>(EndPoints.Notifications, {
      filter: {
        Start: 0,
        Count: 10,
      },
    });

  const { mutate } = usePostData(EndPoints.NotificationOpened);
  const playSound = useSound("/sounds/notification_sound.mp3");

  const [connection, setConnection] = useState<signalR.HubConnection | null>(
    null,
  );

  const queryClient = useQueryClient();

  const handleRefetchQueries = (type: string) => {
    queryClient.refetchQueries({
      queryKey: [EndPoints.Notifications],
      exact: false,
    });
    if (type === "DOCUMENT") {
      queryClient.refetchQueries({
        queryKey: [EndPoints.GetSpecialty],
        exact: false,
      });
      queryClient.refetchQueries({
        queryKey: [EndPoints.GetPersonalInfo],
        exact: false,
      });
    }
    if (type === "APPOINTMENT") {
      refetchAllAppointmentsApis(queryClient);
    }
  };

  useEffect(() => {
    const connectSignalR = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error(
          "❌ لا يوجد رمز مميز (token)، لا يمكن الاتصال بـ SignalR.",
        );
        return;
      }

      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl(
          `${AppConfig.SignalR_URL}${EndPoints.NotificationHub}?Authorization=${token}`,
        )
        .withAutomaticReconnect([0, 2000, 5000, 10000]) // أوقات المحاولة: فورًا، بعد 2 ثانية، بعد 5 ثوانٍ، بعد 10 ثوانٍ
        // .configureLogging(signalR.LogLevel.Debug)
        .configureLogging(signalR.LogLevel.None)
        .build();
      refetch();

      newConnection.on("ReceiveNotification", (newNotification: any) => {
        handleRefetchQueries(newNotification.type);
        refetch();
        setNewNotification(newNotification);
        newNotification?.sound && playSound();
      });

      newConnection.onclose(async (error) => {
        if (error) {
          console.error("⚠️ انقطع اتصال SignalR مع خطأ:", error);
        } else {
          console.warn("ℹ️ تم إغلاق اتصال SignalR بسلاسة.");
        }
        console.warn("♻️ محاولة إعادة الاتصال خلال 5 ثوانٍ...");
        setTimeout(() => {
          connectSignalR();
        }, 5000);
      });

      newConnection.onreconnecting((error) => {});

      newConnection.onreconnected(() => {});

      try {
        await newConnection.start();
      } catch (err) {}

      setConnection(newConnection);
    };

    connectSignalR();

    return () => {
      if (connection) {
        connection.stop().then();
      }
    };
  }, []);

  const handleNotificationClick = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      (notificationsData?.Data?.UnseenCount ?? 0) > 0 &&
        mutate(
          {},
          {
            onSuccess: (data: unknown, variables: void, context: unknown) => {
              queryClient.refetchQueries({
                queryKey: [EndPoints.Notifications],
                exact: false,
              });
            },
          },
        );
    }
  };

  return (
    <>
      <Dropdown
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        overlay={
          <NotificationPopUp
            data={notificationsData?.Data}
            onClose={() => {
              refetch();
              setIsOpen(false);
            }}
          />
        }
      >
        <div className="main_warper relative" onClick={handleNotificationClick}>
          {(notificationsData?.Data?.UnseenCount ?? 0) > 0 && (
            <div className="absolute start-5 top-1.5 z-10 h-2 w-2 rounded-full bg-error">
              {/* {(notificationsData?.Data?.UnseenCount ?? 0) > 99
                  ? "+99"
                  : notificationsData?.Data?.UnseenCount} */}
            </div>
          )}
          <img
            className="h-[18px] w-[18px] cursor-pointer"
            src={ic_notification}
            alt="Notifications"
          />
        </div>
      </Dropdown>

      {!!newNotification && (
        <NotificationToast
          show={!!newNotification}
          onClose={() => setNewNotification(undefined)}
          item={newNotification}
        />
      )}
    </>
  );
}

export default Notifications;
